import { useQuery } from '@tanstack/react-query';
import { fetchReadiness } from '../lib/api';

export function HomePage() {
  const readiness = useQuery({ queryKey: ['readiness'], queryFn: () => fetchReadiness() });

  const status = readiness.isPending
    ? 'Comprobando el servidor…'
    : readiness.isError || readiness.data?.status !== 'ok'
      ? 'El servidor no está disponible.'
      : 'Servidor disponible.';

  return (
    <>
      <h1>Bienvenido a AILAB</h1>
      <p>Esta es la nueva versión de AILAB en construcción.</p>
      <p role="status">{status}</p>
    </>
  );
}
